import adjustToTimeZone from "../common/utils/adjustToTimeZone";
import User from "./User";

let counter = 0;

function extractDate(dateStr = "") {
  const exp = new Date(dateStr);
  if (exp.getTime()) return exp;

  const utc = new Date(Date.parse(dateStr.replace(/-/g, "/")));
  if (utc.getTime()) return utc;

  return null;
}

class Contribution {
  constructor(data) {
    this.id = String(data.id) || `${(counter += 1)}-${new Date().getTime()}`;
    this.createdAt = adjustToTimeZone(extractDate(data.date_created));
    this.additionalInfo = data.additional_info || [];
    this.canEdit = data.can_edit;
    this.confirmedByFunctionalStudy = data.confirmedByFunctionalStudy;
    this.type = data.article ? "pubmed" : "flag";
    this.diseases = data.diseases || [];
    this.phenotypes = data.phenotypes || [];
    this.comment = data.comment;
    this.pathogenicity = data.pathogenicity;
    this.pubmedRefs = data.pub_med_references || [];
    this.user = data.user ? new User(data.user) : null;
    this.organisation = null;
    this.coAuthor = data.coAuthor;
    this.isSaphetorCuratorLinked = data.isSaphetorCuratorLinked;
    this.variantId = null;
    this.data = data;
  }

  setUser(userInstance) {
    this.user = userInstance;
    return this;
  }

  setVariantId(variantId) {
    this.variantId = String(variantId);
    return this;
  }

  setOrganisation(orgInstance) {
    this.organisation = orgInstance;
    return this;
  }
}

export default Contribution;
